import { useEffect } from 'react'
import { useMode } from './useMode'

/**
 * Applies the resolved mode (dark/light) to document.body classes.
 */
export function useModeInitialization() {
  const { resolvedMode } = useMode()

  useEffect(() => {
    if (resolvedMode === 'dark') {
      document.body.classList.add('dark')
      document.body.classList.remove('light')
    } else {
      document.body.classList.remove('dark')
      document.body.classList.add('light')
    }
  }, [resolvedMode])
}
